(function($, Drupal) {
  Drupal.behaviors.bokaParagraphHeadlines = {
    attach(context) {
      once(
        "bokaParagraphHeadlines",
        ".paragraph--type--headlines, .page-blogs",
        context
      ).forEach(headline => {
        const $headline = $(headline);
        const activeClass = "active";
        const lastClass = "--last-in-row";
        const hideClass = "--hide";
        const itemSelector =
          ">.field__items >.field__item, >.view-content >.views-row";

        function initHeadines() {
          const numberInRow = Math.floor(
            $headline.outerWidth() /
              $(itemSelector, $headline)
                .first()
                .outerWidth()
          );

          let savedTransition = false;
          // Resetting all items.
          $(itemSelector, $headline).each(function() {
            if (!savedTransition) {
              // Save the transition effects.
              const tmp = $(this).css("transition");
              if (tmp !== "none") {
                savedTransition = tmp;
              }
            }
            $(this).css("transition", "none");
            $(this)
              .removeClass(activeClass)
              .removeClass(lastClass)
              .removeClass(hideClass);
            $(this).height("auto");
          });

          $(itemSelector, $headline).each(function(index) {
            // Mark each last in row.
            if ((index + 1) % numberInRow === 0) {
              $(this).addClass(lastClass);
            }
            $(this).height($(this).height());
            // Restore the transition effects.
            $(this).css("transition", savedTransition);
          });
        }
        initHeadines();

        $(window).resize(function() {
          // Re-init headlines on screen resize.
          initHeadines();
        });

        // Handle click on item.
        $(itemSelector, $headline).click(function() {
          if ($(this).hasClass(activeClass)) {
            // Deactivate current item.
            $(this).removeClass(activeClass);
            $(itemSelector, $headline).each(function() {
              // Show all hidden items.
              $(this).removeClass(hideClass);
            });
          } else {
            $(itemSelector, $headline).each(function() {
              // Deactivate all items and ahow all hidden items.
              $(this).removeClass(activeClass);
              $(this).removeClass(hideClass);
            });

            const numberInRow = Math.floor(
              $headline.outerWidth() / $(this).outerWidth()
            );
            // Activate current item.
            $(this).addClass(activeClass);
            // Determine which item should be hidden.
            if (numberInRow > 1) {
              if ($(this).hasClass(lastClass)) {
                $(this)
                  .prev()
                  .addClass(hideClass);
              } else {
                $(this)
                  .next()
                  .addClass(hideClass);
              }
            }
          }
        });
      });
    }
  };

  Drupal.behaviors.bokaParagraphCompanies = {
    attach(context) {
      once(
        "bokaParagraphCompanies",
        ".paragraph--type--companies",
        context
      ).forEach(paragraph => {
        const $paragraph = $(paragraph);
        const activeClass = "active";
        $(".view-content .views-row", $paragraph).each(function() {
          const $row = $(this);
          $row.click(function() {
            let target = ".--dropdown";
            let deactivateTarget = ".--dropdown-mobile";
            if ($(document).width() < 768) {
              deactivateTarget = ".--dropdown";
              target = ".--dropdown-mobile";
            }
            $(deactivateTarget).removeClass(activeClass);

            const $dropdown = $(this)
              .nextAll(target)
              .first();
            if ($(this).hasClass(activeClass)) {
              $dropdown.removeClass(activeClass);
              $(this).removeClass(activeClass);
            } else {
              $(`.${activeClass}`, $paragraph).removeClass(activeClass);
              $dropdown.html($(".--content", $(this)).html());
              $dropdown.addClass(activeClass);
              $(this).addClass(activeClass);
            }
          });
        });
      });
    }
  };
})(jQuery, Drupal);
